export default __webpack_public_path__ + "media/images/screen_federation-8bd8f7a8272cbcfa7caea060120acac0.svg";